export const VIEWS = {
    ISSUES: 'ISSUES',
    ANALYTICS: 'ANALYTICS'
};